// Roles as the server defines them.
//
//   platform_admin  PrimeHive. Creates companies, sees every customer.
//   company_admin   The customer's own administrator. Their users and devices.
//   user            Sees the dashboards assigned to them.
export const PLATFORM_ADMIN = 'platform_admin';
export const COMPANY_ADMIN = 'company_admin';
export const USER = 'user';

// The role that 'platform_admin' replaced. A signed-in user's role is read from
// localStorage, written at login, and tokens last 30 days - so for a while after
// this ships there are sessions still carrying the old value. Treating it as
// what it always meant avoids signing the whole shop floor out to rename a
// string. Remove once those sessions have turned over.
const LEGACY_PLATFORM_ADMIN = 'admin';

export const isPlatformAdmin = (role) =>
  role === PLATFORM_ADMIN || role === LEGACY_PLATFORM_ADMIN;

export const isCompanyAdmin = (role) =>
  role === COMPANY_ADMIN;

/** Anyone who should be offered an administration area at all. */
export const isAnyAdmin = (role) =>
  isPlatformAdmin(role) || isCompanyAdmin(role);
